import { Button, IButtonProps } from '@vfit/shared/atoms';
import { AppMobile } from '@vfit/shared/data-access';

const ButtonCBU = (props: IButtonProps) => {
  const getCBUVariant = () => {
    const currentVariant = props.variant;
    if (AppMobile.checkIsApp()) {
      if (currentVariant === 'primary') return 'mva:primary';
      if (currentVariant === 'secondary') return 'mva:alt1';
      return currentVariant;
    }
    return currentVariant;
  };

  return <Button {...props} variant={getCBUVariant()} />;
};

export default ButtonCBU;
